
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default{
name: 'AppFooter',
components: {
Tabbar,
TabbarItem,
},
data(){
return{
index:0
}
},
methods:{
onclick1(){
console.log(1);
}
}

}




// WEBPACK FOOTER //
// ./src/components/Footer.vue